import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50 rounded-t-3xl mt-16 md:mt-20">
      <div className="px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {/* CTA Column */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
              Ezzogenics
            </h3>
            <p className="text-background-300 text-sm leading-relaxed mb-6">
              Certified fire safety services for commercial, industrial, and residential properties across Singapore.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Get a Free Quote
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>

          {/* Navigation Links */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  Contact & Upload
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/resources/fire-safety-regulations" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  Fire Safety Regulations
                </Link>
              </li>
              <li>
                <Link to="/resources/safety-at-work" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  Safety at Work
                </Link>
              </li>
              <li>
                <Link to="/resources/types-of-fires" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  Types of Fires
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 uppercase tracking-wider">
              Our Services
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/fire-risk-assessment" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  Fire Risk Assessment
                </Link>
              </li>
              <li>
                <Link to="/fire-alarm-systems" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  Fire Alarm Systems
                </Link>
              </li>
              <li>
                <Link to="/fire-suppression-systems" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  Fire Suppression Systems
                </Link>
              </li>
              <li>
                <Link to="/emergency-lighting" className="text-background-300 text-sm hover:text-background-50 transition-colors">
                  Emergency Lighting
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 uppercase tracking-wider">
              Contact Us
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-accent-400 text-sm"></i>
                </div>
                <span className="text-background-300 text-sm">
                  Blk 15 Kaki Bukit Road 4, #01-44 Bartley Biz Centre, Singapore 417808
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-whatsapp-line text-accent-400 text-sm"></i>
                </div>
                <a href="https://wa.me/6585353868" target="_blank" rel="noopener noreferrer" className="text-background-300 text-sm hover:text-background-50 transition-colors">+65 8535 3868</a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-accent-400 text-sm"></i>
                </div>
                <a href="mailto:david@ezzogenics.com" className="text-background-300 text-sm hover:text-background-50 transition-colors">david@ezzogenics.com</a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-accent-400 text-sm"></i>
                </div>
                <span className="text-background-300 text-sm">Mon–Fri: 9:00 AM – 6:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-foreground-800 mt-10 md:mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            © 2026 Ezzogenics. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-background-400 hover:text-background-50 transition-colors" aria-label="Facebook">
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-background-400 hover:text-background-50 transition-colors" aria-label="LinkedIn">
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-background-400 hover:text-background-50 transition-colors" aria-label="Instagram">
              <i className="ri-instagram-fill text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}